export const RUPIN_MIGRATION_BANNER_DISMISSED_KEY =
  "rupinMigrationBannerDismissed";
export const RUPIN_MIGRATION_BANNER_LOGIN_COUNT_KEY =
  "rupinMigrationBannerLoginCount";
export const MAX_MIGRATION_BANNER_LOGIN_COUNT = 3;

export const incrementMigrationBannerLoginCount = () => {
  const current = Number(
    localStorage.getItem(RUPIN_MIGRATION_BANNER_LOGIN_COUNT_KEY) || 0,
  );
  localStorage.setItem(
    RUPIN_MIGRATION_BANNER_LOGIN_COUNT_KEY,
    String(current + 1),
  );
};

export const dismissMigrationBanner = () => {
  localStorage.setItem(RUPIN_MIGRATION_BANNER_DISMISSED_KEY, "true");
};

export const shouldShowMigrationBanner = () => {
  if (localStorage.getItem(RUPIN_MIGRATION_BANNER_DISMISSED_KEY) === "true") {
    return false;
  }

  const loginCount = Number(
    localStorage.getItem(RUPIN_MIGRATION_BANNER_LOGIN_COUNT_KEY) || 0,
  );

  return loginCount > 0 && loginCount <= MAX_MIGRATION_BANNER_LOGIN_COUNT;
};
